import styled from 'styled-components';

const ToolbarButtonOld = styled.button`
  border: none;
  float: left;
  background-color: ${props => props.theme.color.wfBlack};
  color: ${props => props.theme.color.wfWhite};
  height: 44px;
  width: 34px;
  margin-top: 2px;
  padding-bottom: 4px;
  display: inline-block;
  transition: color 100ms ease-in-out, border-bottom 100ms ease-in-out;
  border-bottom: ${props =>
    props.isActive && `3px solid ${props.theme.color.wfWhite}`};
  cursor: pointer;
  &:hover,
  &[data-active='true'] {
    border-bottom: 3px solid ${props => props.theme.color.wfWhite};
  }
`;

const ToolbarButtonNew = styled.span(({ theme }) => {
  return {
    cursor: 'pointer',
    borderRadius: 2,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 24,
    height: 24,
    background: 'transparent',
    '&:hover': {
      background: theme.color.wfGrey100,
    },
  };
});

export { ToolbarButtonOld, ToolbarButtonNew };
